module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/yljh.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fyljh.png
// module id = 2N7I
// module chunks = 93